import { forwardRef } from 'react'
import { useSelector } from 'react-redux'
import { useNetworkStatus } from 'builder/hooks/useNetworkStatus'
import { selectors } from 'builder/modules/rendering'
import PdfPreview from 'builder/components/PdfPreview'
import SsrPreview from 'builder/components/SsrPreview'
import OfflinePreview from 'builder/components/OfflinePreview'
import { RENDERERS } from 'builder/modules/constants'
import { PreviewComponentProps } from './types'

type PreviewComponentType = typeof PdfPreview | typeof SsrPreview | typeof OfflinePreview

export const Preview = forwardRef((props: PreviewComponentProps, ref) => {
  let renderer = useSelector(selectors.renderer)
  let isOnline = useNetworkStatus()

  let PreviewComponent: PreviewComponentType =
    renderer === RENDERERS.server ? SsrPreview : PdfPreview
  if (!isOnline) PreviewComponent = OfflinePreview

  return <PreviewComponent {...{ ref, ...props, renderer }} />
})
